import { render, staticRenderFns } from "./InfectionCaseDetail.vue?vue&type=template&id=49bdac23&"
import script from "./InfectionCaseDetail.vue?vue&type=script&lang=js&"
export * from "./InfectionCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./InfectionCaseDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports